import { QuoteStatuses } from '@cpak/adp-cpak-quotes-service-models';

export const restrictSaveToSalesforceForStatuses = [
  QuoteStatuses.validationRequested,
  QuoteStatuses.customerApprovalRequested,
  QuoteStatuses.pricingApprovalRequested,
  QuoteStatuses.customerPriceSetup,
  QuoteStatuses.contractRequested,
  QuoteStatuses.prototypeRequested,
];
